import axios from "axios"
import * as types from "../mutation-types"
import api from "../../api/api"

export const state = {
    pagination: {
        from: 0,
        to: 0,
        totalPage: 0,
        path: "",
        currentPage: 1,
        totalRecord: 0,
        perPage: 10
    },
    shortLeaveRequests: []
}

// getters
export const getters = {
    shortLeaveRequests: state => state.shortLeaveRequests,
    pagination: state => state.pagination
}

// mutations
export const mutations = {
    [types.SHORT_LEAVE_REQUEST.FETCH_SHORT_LEAVE_REQUEST](
        state,
        responseData
    ) {
        state.shortLeaveRequests = responseData.data
        state.pagination.from = responseData.pagination.from
        state.pagination.to = responseData.pagination.to
        state.pagination.totalPage = responseData.pagination.last_page
        state.pagination.path = responseData.pagination.path || ""
        state.pagination.currentPage = responseData.pagination.current_page
        state.pagination.totalRecord = responseData.pagination.total
        state.pagination.perPage = responseData.pagination.per_page
    },

    [types.SHORT_LEAVE_REQUEST.SET_PAGINATION](state, pagination) {
        state.pagination = { ...state.pagination, ...pagination }
    }
}

// actions
export const actions = {
    async listShortLeaveRequests({ commit }, payload) {
        const response = await axios.get(api.LIST_SHORT_LEAVE_REQUEST, {
            params: {
                per_page: payload.per_page || 10,
                current_page: payload.current_page || 1,
                staff_id: payload.staff_id,
                start_date: payload.start_date,
                end_date: payload.end_date,
                start_time: payload.start_time,
                end_time: payload.end_time,
                leave_type: payload.leave_type,
                assigned_staff: payload.assigned_staff,
                sort_column: payload.sort_column,
                sort_by: payload.sort_by
            }
        })
        if (response.status === 'success') {
            commit(
                types.SHORT_LEAVE_REQUEST.FETCH_SHORT_LEAVE_REQUEST,
                response
            )
        }
    },

    async listShortLeaveRequestsAssign({ commit }, payload) {
        const response = await axios.get(api.LIST_SHORT_LEAVE_REQUEST_ASSIGN, {
            params: {
                per_page: payload.per_page || 10,
                current_page: payload.current_page || 1,
                staff_id: payload.staff_id,
                start_date: payload.start_date,
                end_date: payload.end_date,
                start_time: payload.start_time,
                end_time: payload.end_time,
                leave_type: payload.leave_type,
                assigned_staff: payload.assigned_staff,
                sort_column: payload.sort_column,
                sort_by: payload.sort_by
            }
        })
        if (response.status === 'success') {
            commit(
                types.SHORT_LEAVE_REQUEST.FETCH_SHORT_LEAVE_REQUEST,
                response
            )
        }
    }
}